import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'
import { TranslateServiceService } from '../services/translate-service.service';
import { SpecialPagesService } from '../services/special-pages.service';
import { Router } from '@angular/router';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  goal: any;
  quantityDonors: any;
  totalCollected: any;
  hasMerchant: boolean;
  logoRace: string;
  headerBg: string;
  goalBarBg: string;
  languagesFlag: boolean = false;

  // Race data
  raceUrl: string;
  raceId: string;

  // Pages
  pagesList: any;

  // Translate service
  notCurrentLanguage: string;
  text: any;
  currentLanguageNav: string = "es";
  joinUs: any;
  // Menu
  openMenuMobile: boolean = false;

  // Config
  hasManyLanguages: boolean = false;
  userIsLogged: boolean = false;
  collectorAvatar: string;
  collectorUrl: string;
  showSubMenu: boolean = false;
  logoLink: string = '#';
  // Languages Config
  languagesList: any = false;
  languageDefault: string;

  // All races config
  hasRaceUrl: boolean = true;

  // Login config
  lCollectorTeam: string = '';
  lCollectorUrl: string = '';
  lCollectorUpdateUrl: string = '';

  // All races config
  logoAllRaces: string = null;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private specialPagesService: SpecialPagesService,
    private router: Router,
  ) {
    let _ = this;
  }

  ngOnInit() {
    let _ = this;
    _.raceUrl = _.getRaceName();
    _.showJustLogo();
    _.isLogged();
    if (!_.getRaceName()){
      _.configByMerchant();
      _.logoLink = _.getMerchant();
    }else{
      _.logoLink = _.getMerchant() + '/' + _.getRaceName();
    }
  }

  isBecar(){
    const _ = this;
    return _.getMerchant() == 'becar';
  }

  ngAfterViewInit(){
    let _ = this;
    _.getQuantities();
  }

  isLogged(){
    let _ = this;
    let hasToken = localStorage.getItem('tokenL');
    if(hasToken){
      _.userIsLogged = true;
      _.collectorAvatar = localStorage.getItem('avatarC') != "null" ? 'url(' + localStorage.getItem('avatarC') + ')' : "#ddd";
      _.lCollectorTeam = localStorage.getItem('teamC');
      _.lCollectorUrl = localStorage.getItem('userUrlC');
    }
  }

  changeLanguage() {
    let _ = this;
    _.translateService.changeLanguage();
    window.location.reload();
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage(_.languageDefault.toUpperCase()) === 'EN';

    _.translateService.getJSON("assets/translations/navbar.translations.json")
    .subscribe((res)=> {
      if(isEN){
        _.text = res.english;
        _.notCurrentLanguage = 'ES';
        _.currentLanguageNav = 'en';
        localStorage.setItem('language', "EN");
      }else{
        _.text = res.spanish;
        _.notCurrentLanguage = 'EN';
        _.currentLanguageNav = 'es';
        localStorage.setItem('language', "ES");
      }
    });
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');
    let hasSomeQuery = raceName[4] != undefined ? raceName[4].includes('?') : false;
    if(hasSomeQuery) {
      let raceWithoutStatus = raceName[4].split('?')[0];
      return raceWithoutStatus;
    }
    console.log(raceName[4]);
    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getQuantities(){
    let _ = this;
    let conditions = {
      "conditions": {
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      document.title = data['results'][0].name;
      _.languagesList = data['results'][0].design.languages.languages;
      _.raceId = data['results'][0].race_id;
      _.goal = data['results'][0].goal;
      _.quantityDonors = data['results'][0].quantity_donors;
      _.totalCollected = data['results'][0].total_collected;
      _.logoRace = data['results'][0].design.images.logo_header;
      _.headerBg = data['results'][0].design.color.header;
      _.goalBarBg = data['results'][0].design.color.secundary;
      _.languagesFlag = _.languagesList.length > 1 ? true : false;
      _.languageDefault = data['results'][0].design.languages.default;
      _.getCurrentLanguage();
      _.getPages();
    })
  }

  getPages(){
    let _ = this;
    let conditions = {
      "conditions":{},
      "race_id": _.raceId,
      "merchant": _.getMerchant()
    }

    _.apiService.getPages(conditions).subscribe(data => {
      console.log(data);
      _.pagesList = data['results'];
    })
  }

  specialPage(title, html, url){
    let _ = this;
    _.specialPagesService.htmlPage =  html;
    _.router.navigate(['/' + _.getMerchant() + '/' + _.getRaceName() + '/dynamic/' + url]);
  }

  showJustLogo(){
    let _ = this;
    if(!_.getRaceName()){
      _.hasRaceUrl = false;
    }
  }

  logout(){
    localStorage.removeItem('tokenL');
    localStorage.removeItem('avatarC');
    localStorage.removeItem('emailC');
    localStorage.removeItem('userIdC');
    location.reload();
  }

  configByMerchant(){
    let _ = this;
    let conditions = {
     "conditions":{
        "merchant": _.getMerchant(),
      },
    }
    _.apiService.getMerchantDesign(conditions).subscribe(data => {
      _.logoAllRaces = data['results'][0].design.logo;
    })
  }
}
